import * as React from "react";
import PropTypes from 'prop-types';

const SvgJcPenneyBlack = props => {
  if (props.id !== "_svgjcpenneyblack") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><g fillRule="evenodd"><rect width={25.6} height={16.119} x={3.2} y={8} rx={0.796} /><path d="M8.618 17.56c.255.58.836.94 1.522.94.642 0 1.21-.315 1.482-.823.12-.225.171-.513.171-.965v-3.744h-1.025v3.861c0 .305-.052.436-.13.537a.614.614 0 01-.49.227c-.406 0-.589-.316-.652-.47l-.878.436zm8.826-.663a1.94 1.94 0 01-1.506.696c-.517 0-.995-.195-1.344-.546a1.893 1.893 0 01-.546-1.35c0-1.064.81-1.898 1.843-1.898.469 0 .916.178 1.272.504l.658-.698a2.852 2.852 0 00-1.92-.712c-.81 0-1.548.29-2.075.815a2.787 2.787 0 00-.801 1.99c0 .766.288 1.473.808 1.99.531.525 1.271.816 2.082.816.903 0 1.711-.356 2.236-.98l-.707-.627zm3.87-.957h-.927v-2.027h.927a.995.995 0 011.021 1.012.993.993 0 01-1.02 1.014m1.489-2.4a1.978 1.978 0 00-1.412-.572h-2.026v5.46h1.023v-1.54h.996a1.99 1.99 0 001.419-.571c.363-.363.564-.857.564-1.389a1.962 1.962 0 00-.564-1.389" fill="#FFF" fillRule="nonzero" /></g></svg>;
};

SvgJcPenneyBlack.displayName = "_svgjcpenneyblack";
SvgJcPenneyBlack.propTypes = {
  id: PropTypes.string
};
SvgJcPenneyBlack.defaultProps = {
  id: ''
};
export default SvgJcPenneyBlack;